(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["section-main-search"] && !Shopify.designMode) return;
  try {
    class SearchExperience extends HTMLElement {
    connectedCallback() {
      if (this.dataset.enhanced === 'true') return;
      this.dataset.enhanced = 'true';
      this.cards = Array.from(this.querySelectorAll('[data-search-product-card]'));
      this.grid = this.querySelector('[data-search-grid]');
      this.dialog = this.querySelector('[data-filter-dialog]');
      this.countOutput = this.querySelector('[data-visible-result-count]');
      this.filterEmpty = this.querySelector('[data-filter-empty]');
      this.filterBadge = this.querySelector('[data-active-filter-count]');

      this.querySelectorAll('[data-search-clear]').forEach((button) => {
        button.addEventListener('click', () => {
          const input = this.querySelector('.search-experience__input');
          if (!input) return;
          input.value = '';
          input.focus();
        });
      });

      this.querySelectorAll('[data-filter-availability], [data-filter-min-price], [data-filter-max-price]').forEach((control) => {
        const eventName = control.matches('input[type="number"]') ? 'input' : 'change';
        control.addEventListener(eventName, () => {
          this.syncControl(control);
          this.applyFilters();
        });
      });

      this.querySelectorAll('[data-search-sort]').forEach((select) => {
        select.addEventListener('change', () => {
          this.syncControl(select);
          this.sortCards(select.value);
        });
      });

      this.querySelectorAll('[data-clear-filters]').forEach((button) => {
        button.addEventListener('click', () => this.clearFilters());
      });

      this.querySelectorAll('[data-grid-view]').forEach((button) => {
        button.addEventListener('click', () => this.setGridView(button.dataset.gridView));
      });

      const openButton = this.querySelector('[data-open-filter-dialog]');
      if (openButton) openButton.addEventListener('click', () => this.openDialog());

      this.querySelectorAll('[data-close-filter-dialog], [data-apply-filters]').forEach((button) => {
        button.addEventListener('click', () => this.closeDialog());
      });

      if (this.dialog) {
        this.dialog.addEventListener('close', () => document.documentElement.classList.remove('search-filter-open'));
      }
    }

    syncControl(source) {
      let selector = '';
      if (source.hasAttribute('data-filter-availability')) {
        selector = `[data-filter-availability="${source.dataset.filterAvailability}"]`;
      } else if (source.hasAttribute('data-filter-min-price')) {
        selector = '[data-filter-min-price]';
      } else if (source.hasAttribute('data-filter-max-price')) {
        selector = '[data-filter-max-price]';
      } else if (source.hasAttribute('data-search-sort')) {
        selector = '[data-search-sort]';
      }
      if (!selector) return;
      this.querySelectorAll(selector).forEach((control) => {
        if (control === source) return;
        if (source.type === 'checkbox') control.checked = source.checked;
        else control.value = source.value;
      });
    }

    applyFilters() {
      const availability = new Set(
        Array.from(this.querySelectorAll('[data-filter-availability]:checked')).map((input) => input.dataset.filterAvailability)
      );
      const minInput = this.querySelector('[data-filter-min-price]');
      const maxInput = this.querySelector('[data-filter-max-price]');
      const minCents = minInput && minInput.value !== '' ? Number(minInput.value) * 100 : 0;
      const maxCents = maxInput && maxInput.value !== '' ? Number(maxInput.value) * 100 : Number.POSITIVE_INFINITY;
      let visible = 0;

      this.cards.forEach((card) => {
        const availabilityMatch = availability.size === 0 || availability.has(card.dataset.available);
        const price = Number(card.dataset.price || 0);
        const priceMatch = price >= minCents && price <= maxCents;
        card.hidden = !(availabilityMatch && priceMatch);
        if (!card.hidden) visible += 1;
      });

      if (this.countOutput) {
        const label = visible === 1 ? this.dataset.resultSingular : this.dataset.resultPlural;
        this.countOutput.textContent = `${visible} ${label}`;
      }
      if (this.filterEmpty) this.filterEmpty.hidden = visible !== 0;
      this.updateFilterBadge(availability.size, minInput?.value, maxInput?.value);
    }

    updateFilterBadge(availabilityCount, minValue, maxValue) {
      if (!this.filterBadge) return;
      const count = availabilityCount + (minValue ? 1 : 0) + (maxValue ? 1 : 0);
      this.filterBadge.textContent = String(count);
      this.filterBadge.hidden = count === 0;
    }

    clearFilters() {
      this.querySelectorAll('[data-filter-availability]').forEach((input) => { input.checked = false; });
      this.querySelectorAll('[data-filter-min-price], [data-filter-max-price]').forEach((input) => { input.value = ''; });
      this.applyFilters();
    }

    sortCards(value) {
      if (!this.grid) return;
      const sorted = [...this.cards].sort((a, b) => {
        if (value === 'price-ascending') return Number(a.dataset.price) - Number(b.dataset.price);
        if (value === 'price-descending') return Number(b.dataset.price) - Number(a.dataset.price);
        return Number(a.dataset.index) - Number(b.dataset.index);
      });
      sorted.forEach((card) => this.grid.append(card));
    }

    setGridView(view) {
      this.dataset.mobileGrid = view;
      this.querySelectorAll('[data-grid-view]').forEach((button) => {
        const active = button.dataset.gridView === view;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', String(active));
      });
    }

    openDialog() {
      if (!this.dialog) return;
      document.documentElement.classList.add('search-filter-open');
      if (typeof this.dialog.showModal === 'function') this.dialog.showModal();
      else this.dialog.setAttribute('open', '');
    }

    closeDialog() {
      if (!this.dialog) return;
      if (typeof this.dialog.close === 'function' && this.dialog.open) this.dialog.close();
      else this.dialog.removeAttribute('open');
      document.documentElement.classList.remove('search-filter-open');
    }
  }

  if (!customElements.get('search-experience')) customElements.define('search-experience', SearchExperience);
  } catch(e) { console.error(e); }
})();

})();
